import React, { useContext, useEffect } from "react";
import { signInWithEmailAndPassword } from "firebase/auth";
import { auth } from "../firebaseConfig";
import { useNavigate, NavLink } from "react-router-dom";
import "../css/index.css";

function Login() {

    const navigate = useNavigate();

    async function handleSubmit(event) {
        event.preventDefault();

        const email = event.target[0].value;
        const password = event.target[1].value;
        try {
            await signInWithEmailAndPassword(auth, email, password);
            navigate("/");
        } catch (error) {
            alert(error.message);
        }
    }

    return (
        <div className="login">
            <div className="login-container">
                <div className="logo">
                    <h3>Write Blog</h3>
                    <p>Login</p>
                </div>
                <form className="login-form" onSubmit={handleSubmit}>
                    <input placeholder="email" type="email"></input>
                    <input placeholder="password" type="password"></input>
                    <button type="submit">Sign in</button>
                    <p className="account">Don't have an account?
                        <NavLink to="/register">Register</NavLink></p>
                </form>
            </div>
        </div>
    );
}

export default Login;